<template>
    <v-container>
        <v-row
            class="mt-7"
            no-gutters
        >
            <v-col
                class="ma-0 pa-0"
            >
                <v-row
                    class="mx-5 my-0 pa-0 d-flex"
                    justify="end"
                    no-gutters
                >
                    <v-switch
                        v-model="subscription"
                        color="blue"
                        class="ma-0 pa-0"
                    />
                </v-row>

                <v-text-field
                    v-model="paymentMethod"
                    label="Payment Method"
                    outlined
                    class="px-5"
                    :disabled="!subscription"
                />
                <v-text-field
                    v-model="accountInfo.street_address"
                    label="Billing Street"
                    outlined
                    class="px-5 mt-3"
                    disabled
                />
                <v-row
                    class="align-content-center"
                >
                    <v-col
                        class="mx-5 mb-0 pb-0 d-flex flex-nowrap"
                    >
                        <v-col
                            cols="6"
                            class="ma-0 pa-0"
                        >
                            <v-text-field
                                v-model="accountInfo.city"
                                label="City"
                                outlined
                                class="mr-2"
                                disabled
                            />
                        </v-col>
                        <v-col
                            cols="3"
                            class="ma-0 pa-0"
                        >
                            <v-text-field
                                cols="2"
                                v-model="accountInfo.state"
                                label="State"
                                outlined
                                class="mr-2"
                                disabled
                            />
                        </v-col>
                        <v-col
                            cols="3"
                            class="ma-0 pa-0"
                        >
                            <v-text-field
                                cols="2"
                                v-model="accountInfo.zip"
                                label="Zip"
                                outlined
                                disabled
                            />
                        </v-col>
                    </v-col>
                </v-row>
            </v-col>
        </v-row>
        <v-row>
            <v-col
                class="ma-0 pa-0 ml-5"
            >
                <v-row
                    no-gutters
                    align="start"
                >
                    integrate with Stripe for selecting plan, updating payment information, and viewing payment history
                </v-row>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
export default {
    name: 'billing',
    data: () => ({
        subscription: true,
        paymentMethod: 'Visa **** **** **** 1234',
    }),

    computed: {
        accountInfo() {
            return this.$store.getters['data/account'];
        },
    } 
};
</script>
